/* Hype pages — sticky header.
   Rewrites the shared sticky-atc snippet into the single "shop now" button
   the hype pages use, then wires the reveal/hide behaviour that other hype
   sections opt into with data-hype-header-reveal / data-hype-header-hide. */

(function () {
  function init() {
    var wrapper = document.getElementById("header-wrapper");
    if (!wrapper || wrapper.dataset.hypeHeaderReady === "true") return;
    wrapper.dataset.hypeHeaderReady = "true";

    /* ScrollSmoother puts a transform on #hype-smooth-content, and a
       transformed ancestor makes position: fixed resolve against that element
       instead of the viewport. Lift the header clear of it.

       It has to land inside #page: sticky-atc.css scopes the whole dropdown,
       including its open state, through "#pdp-sticky-nav-test ~ #page
       #sticky-atc ...", so a header parked on the body loses every one of
       those rules. #page is an ancestor of the smooth wrapper, so it is both
       outside the transform and inside that selector.

       Moving a node keeps its listeners, so this is safe to do after
       sticky-atc.js has wired itself up. */
    if (wrapper.closest("#hype-smooth-content")) {
      var host = document.getElementById("page") || document.body;
      wrapper.setAttribute("data-hype-lifted", "true");
      host.appendChild(wrapper);
    }

    var header = wrapper.querySelector(".hype-sticky-header");
    var stickyAtc = wrapper.querySelector("#sticky-atc");
    if (!stickyAtc) return;

    var style = wrapper.getAttribute("data-header-style") || "swatches";
    var handle = wrapper.getAttribute("data-product-handle") || "";
    var subtitle = wrapper.getAttribute("data-header-subtitle-text") || "";
    var buttonText =
      style === "swatches"
        ? "Shop now"
        : wrapper.getAttribute("data-non-swatch-button-text") || "Shop now";

    stickyAtc.setAttribute("data-style", style);

    /* Collapse the two add-to-cart / contact-sales buttons down to one link
       straight to the PDP. */
    var buttonContainers = wrapper.querySelectorAll(".sticky-atc__button-container");
    for (var i = buttonContainers.length - 1; i > 0; i--) {
      buttonContainers[i].remove();
    }
    if (buttonContainers[0]) {
      buttonContainers[0].innerHTML =
        '<a href="/products/' +
        handle +
        '" class="btn product-tile__button" shop-now-plp="" promo-style="true" ' +
        'promo-style-on-hover="true" data-extra-bottom-margin="true" data-updated="true">' +
        "<span>" +
        buttonText +
        "</span></a>";
    }

    var reviewsBadge = wrapper.querySelector(".stamped-product-reviews-badge");
    if (reviewsBadge) reviewsBadge.remove();

    /* Okendo scrolls its star rating to the reviews widget on the same page,
       and hype pages have no widget. Send the click to the PDP instead, where
       okendo-reviews-widget.liquid picks up #reviews and scrolls once the
       widget has loaded. Capture phase so Okendo's own handler never runs. */
    var starRating = wrapper.querySelector("[data-oke-star-rating]");
    if (starRating && handle) {
      starRating.style.cursor = "pointer";
      starRating.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = "/products/" + handle + "#reviews";
        },
        true
      );
    }

    var desktopHeader = wrapper.querySelector(".sticky-atc__desktop-header");
    if (desktopHeader && subtitle) {
      desktopHeader.insertAdjacentHTML(
        "beforeend",
        '<div class="hype-sticky-header__subtitle-container"><p>' + subtitle + "</p></div>"
      );
    }

    var variants = [];
    var variantsJson = wrapper.querySelector("[data-hype-sticky-header-variants]");
    if (variantsJson) {
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (error) {
        variants = [];
      }
    }

    var wordsAttribute = wrapper.getAttribute("data-words-to-be-removed-from-variant-title");
    var wordsToRemove = wordsAttribute ? wordsAttribute.split(",") : undefined;

    var stripVariantText = function (text) {
      var branch = window.Branch && window.Branch.functions;
      return branch && branch.stripVariantText ? branch.stripVariantText(text, wordsToRemove) : text;
    };

    /* ProductJsNew rewrites the bar label on the PDP once the main form picks
       a variant. Hype pages have no main form, so this mirrors that block
       (ProductJs-new.js.liquid, the "Swatches code" loop in selectCallback). */
    var updateBarLabel = function (dropdown, value) {
      var label = dropdown.querySelector(".swatch-dropdown__bar-label");
      if (!label) return;

      label.setAttribute("data-option-value", value.replace(" ", "-").toLowerCase());

      if (label.getAttribute("data-type") === "color") {
        label.className =
          "swatch-dropdown__bar-label swatch-dropdown__bar-label--selected color-" +
          value.replaceAll(" ", "-").replaceAll("/", "-").toLowerCase();
        dropdown
          .querySelectorAll(".swatch-dropdown__open-close-button-container-label")
          .forEach(function (containerLabel) {
            containerLabel.textContent = value;
          });
        return;
      }

      var xsLabel = value.replaceAll(" inches", "″").replaceAll(" Inches", "″");
      var xsLabelArray = value
        .replaceAll(" inches", " inches #")
        .replaceAll(" Inches", " Inches #")
        .split("#");
      if (xsLabelArray.length > 1) {
        xsLabelArray.splice(1, 1);
        xsLabel = xsLabelArray
          .join()
          .replaceAll(" inches", "″")
          .replaceAll(" Inches", "″")
          .replaceAll(",", "")
          .split("+")[0];
      }
      var fullLabel = value.replace(/ ?inches/gi, "″");

      var valueSpan = label.querySelector(
        "span.swatch-dropdown__bar-label-option-value:not(.swatch-dropdown__bar-label-option-value--xs)"
      );
      var xsSpan = label.querySelector("span.swatch-dropdown__bar-label-option-value--xs");
      var hiddenSpan = label.querySelector("span.visually-hidden");
      if (valueSpan) valueSpan.innerHTML = stripVariantText(fullLabel);
      if (xsSpan) xsSpan.innerHTML = stripVariantText(xsLabel);
      if (hiddenSpan) hiddenSpan.innerHTML = fullLabel + " " + label.getAttribute("data-option-key");
    };

    /* Read the selection back off the panels, in option order, and point the
       Shop now link at the matching variant. */
    var updateShopNowLink = function () {
      var link = wrapper.querySelector(".sticky-atc__button-container a");
      if (!link || !handle) return;

      var selected = [];
      stickyAtc
        .querySelectorAll(".swatch-dropdown__sliding-option-selector-outer-container[data-option-index]")
        .forEach(function (panel) {
          var option = panel.querySelector(".swatch-dropdown__sliding-option-selector-element--selected");
          selected[Number(panel.getAttribute("data-option-index"))] = option
            ? option.getAttribute("data-value")
            : null;
        });

      var match = variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return selected[index] == null || selected[index] === value;
        });
      });

      link.href = "/products/" + handle + (match ? "?variant=" + match.id : "");

      var variantInput = stickyAtc.querySelector('input[type="hidden"][name="id[]"]');
      if (variantInput && match) variantInput.value = match.id;
    };

    /* Header swatches update the header itself, the Shop now link, and the
       swatches in the variant inspect section. */
    wrapper
      .querySelectorAll("#sticky-atc .swatch-dropdown__sliding-option-selector-element")
      .forEach(function (element) {
        element.addEventListener("click", function () {
          var dataKey = element.getAttribute("data-key");
          var input = element.querySelector("input");
          var value = input ? input.value : null;
          if (!dataKey || !value) return;
          if (element.classList.contains("option-not-available") || element.classList.contains("soldout")) return;

          var panel = element.closest(".swatch-dropdown__sliding-option-selector-outer-container");
          if (panel) {
            panel
              .querySelectorAll(".swatch-dropdown__sliding-option-selector-element--selected")
              .forEach(function (option) {
                option.classList.remove("swatch-dropdown__sliding-option-selector-element--selected");
              });
          }
          element.classList.add("swatch-dropdown__sliding-option-selector-element--selected");
          input.checked = true;

          var dropdown = element.closest(".swatch-dropdown");
          if (dropdown) updateBarLabel(dropdown, value);
          updateShopNowLink();

          var swatchContainer = document.querySelector(
            '.variant-inspect .swatch[data-option-name="' + dataKey + '"]'
          );
          if (!swatchContainer) return;

          var target = swatchContainer.querySelector(
            '.swatch-element[data-value="' + value + '"] label'
          );
          if (target) target.click();
        });
      });

    if (style === "swatches") updateShopNowLink();

    if (!window.HypeCore || typeof gsap === "undefined") return;

    window.HypeCore.ready(function () {
      if (wrapper.getAttribute("data-hype-header-hidden") !== "true") {
        gsap.set(header, { y: 0, opacity: 1 });
      }

      /* Slide in once the section that owns the reveal scrolls into view. */
      var revealTrigger = document.querySelector("[data-hype-header-reveal]");
      if (revealTrigger && wrapper.getAttribute("data-hype-header-hidden") === "true") {
        gsap.set(header, { y: -150, opacity: 0 });
        gsap.to(header, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: revealTrigger,
            start: "top 50%",
            once: true
          }
        });
      }

      /* Fade out while a full-bleed video section owns the viewport. */
      var hideTrigger = document.querySelector("[data-hype-header-hide]");
      if (!hideTrigger) return;

      gsap.to(header, {
        opacity: 0,
        pointerEvents: "none",
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: hideTrigger,
          start: "top 80%",
          end: "bottom 40%",
          scrub: true,
          toggleActions: "play none none reverse"
        }
      });

      gsap.to(header, {
        opacity: 1,
        pointerEvents: "auto",
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: hideTrigger,
          start: "bottom -100%",
          end: "bottom -130%",
          scrub: true,
          toggleActions: "play none none reverse"
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Theme editor: a re-rendered or removed section leaves behind the copy we
     lifted onto the body, so clear it out by section id. */
  function dropLifted(sectionId) {
    document.querySelectorAll('[data-hype-lifted="true"]').forEach(function (stale) {
      if (!sectionId || stale.getAttribute("data-hype-section-id") === sectionId) stale.remove();
    });
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target.querySelector || !event.target.querySelector("#header-wrapper")) return;
    dropLifted(event.detail && event.detail.sectionId);
    init();
  });

  document.addEventListener("shopify:section:unload", function (event) {
    dropLifted(event.detail && event.detail.sectionId);
  });
})();
